export enum DocumentStatus {
    MISSING = 'MISSING',
    FIX_REQUIRED = 'FIX_REQUIRED',
    SIGNATURE_REQUIRED = 'SIGNATURE_REQUIRED',
    WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
    PREAPPROVED = 'PREAPPROVED',
    APPROVED = 'APPROVED',
}
